<template>
  <div>
    <vh-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :title="$t('host.k_579001')"
      modal
      width="640px"
      custom-class="setting-audience-dialog"
      append-to-body
    >
      <div slot="title">
        {{ $t('host.k_579001') }}
        <vh-tooltip class="item" effect="dark" placement="right" :popper-options="{ zIndex: 4000 }">
          <div slot="content">
            <div class="audience-wrapper_tip">
              {{ $t('host.k_579002') }}
              <br />
              <!-- prettier-ignore -->
              {{ $t('host.k_579003') }}
              <br />
              {{ $t('host.k_579004') }}
              <br />
              <!-- prettier-ignore -->
              {{ $t('host.k_579005') }}
              <br />
              {{ $t('host.k_579006') }}
            </div>
          </div>
          <span class="iconfont-v3 saasicon_help_m"></span>
        </vh-tooltip>
      </div>

      <div class="audience-wrapper">
        <div class="audience-wrapper_list">
          <el-transfers
            ref="transfers"
            :value1.sync="winnerList"
            :value2.sync="blackList"
            :data="audienceList"
            :value4="onlineList"
            :value3="errorList"
            @doSearch="doSearch"
            @doRefresh="doRefresh"
            :titles="[
              $t('host.k_579007'),
              configList.white_list == 1 ? $t('host.k_579008') : '',
              $t('host.k_579009'),
              $t('host.k_579010')
            ]"
          ></el-transfers>
        </div>
        <!-- <div class="audience-wrapper_tip">{{ $t('host.k_579002') }}<br />
        1. 当预设中奖人员少于奖品数时，则中奖用户取全部预设人员+普通参会人员
        <br />
        2.
        当预设中奖人员多于奖品数时，则中奖用户优先取预设人员中的在线用户（随机），组外人员不中奖
        <br />
        3. 以下分组为资料库下导入并创建的观众组，选中组内的用户无需在直播间也可以中奖
        <br />
        4. 以手机号作为关键标识，分组内仅显示有手机号的用户数
        <br />
        5. 若预设的在线用户在抽奖时处于离线状态则无法中奖
      </div> -->
        <div class="audience-wrapper_btn">
          <vh-button
            type="primary"
            :disabled="!(winnerList.length || blackList.length)"
            size="medium"
            round
            v-preventReClick
            @click="sureAudience"
          >
            {{ $t('host.k_579011') }}
          </vh-button>
          <vh-button size="medium" type="info" v-preventReClick plain round @click="handleClose">
            {{ $t('host.k_579012') }}
          </vh-button>
        </div>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import elTransfers from '../Transfer/el-transfer.vue';
  import { useRoomBaseServer, useLotteryServer } from 'middle-domain';
  export default {
    data() {
      return {
        dialogVisible: false,
        total: 0,
        pageInfo: {
          limit: 500,
          pos: 0,
          pageNum: 1
        },
        audienceList: [],
        winnerList: [],
        onlineList: [],
        blackList: [], // 列表
        errorList: [],
        roomId: ''
      };
    },
    components: { elTransfers },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
    },
    computed: {
      userId() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.userinfo.user_id;
      },
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      }
    },
    methods: {
      openSettingAudience(winList, list) {
        this.dialogVisible = true;
        this.winnerList = winList || [];
        this.blackList = list || [];
        this.errorList = [];
        this.initChecked();
        this.getOnlineList();
        this.getAudienceList();
      },

      getAudienceList() {
        const params = {
          limit: this.pageInfo.limit,
          pos: this.pageInfo.pos
        };
        this.lotteryServer.getAudienceList(params).then(res => {
          if (res.code === 200) {
            this.total = res.data.total;
            if (res.data.total) {
              let list = res.data.list.map(item => {
                return {
                  key: item.id + '',
                  subject: item.subject,
                  num: item.audience_num,
                  label: `${item.subject}（${item.audience_num}）`,
                  type: 'group'
                };
              });
              this.audienceList.push(...list);
              const blackList_key = this.blackList.map(item => item.key) || [];
              const winnerList_key = this.winnerList.map(item => item.key) || [];

              const winnerList = list.filter(item => winnerList_key.indexOf(item.key) > -1);
              const blackList = list.filter(item => blackList_key.indexOf(item.key) > -1);
              const winners = this.winnerList.filter(e => e.type == 'user');
              const blacks = this.blackList.filter(e => e.type == 'user');
              this.winnerList = [...winnerList, ...winners] || [];
              this.blackList = [...blackList, ...blacks] || [];
              console.log(this.winnerList, this.blackList, '????123');
            }
          }
        });
      },
      async sureAudience() {
        //点击确定之前，调用刷新操作
        await this.doRefresh();
        const list = [...this.winnerList, ...this.blackList];
        if (this.winnerList.length > 20 || this.blackList.length > 20) {
          this.$vhMessage.error(this.$t('host.k_579013'));
          return;
        }

        const list_key = list.filter(e => e.type == 'group').map(item => item.key) || [];
        const winners = this.winnerList.filter(e => e.type == 'user');
        const blacks = this.blackList.filter(e => e.type == 'user');
        let pass_status = false;
        let del_ids = [];
        if (list_key.length == 0) {
          pass_status = true;
        } else {
          let params = {
            group_ids: list_key.join(','),
            user_id: this.userId
          };
          const res = await this.lotteryServer.checkAudienceStatus(params);
          if (res.code === 200) {
            pass_status = res.data.pass_status;
            if (!pass_status) {
              del_ids = res.data?.del_ids;
            }
          }
        }

        if (pass_status) {
          const winnerList = [];
          const blackList = [];
          const blackList_key = this.blackList.map(item => item.key) || [];
          const winnerList_key = this.winnerList.map(item => item.key) || [];

          this.audienceList.map(item => {
            if (winnerList_key.length && winnerList_key.includes(item.key)) {
              winnerList.push({
                key: item.key,
                subject: item.subject,
                num: item.num,
                type: 'group'
              });
            }
            if (blackList_key.length && blackList_key.includes(item.key)) {
              blackList.push({
                key: item.key,
                subject: item.subject,
                num: item.num,
                type: 'group'
              });
            }
          });

          this.$emit('selectAudience', [...winnerList, ...winners], [...blackList, ...blacks]);
          this.handleClose();
        } else {
          this.dialogVisible = true;
          this.errorList = del_ids.split(',').map(item => Number(item));
        }
      },
      handleReset() {
        this.errorList = [];
        this.audienceList = [];
        this.pageInfo.pageNum = 1;
        this.pageInfo.pos = 0;
      },
      handleClose() {
        this.dialogVisible = false;
        this.handleReset();
      },
      doSearch(txt) {
        this.getOnlineList(txt);
      },
      async doRefresh(txt) {
        await this.getOnlineList(txt);
        // await this.checkUserOnline();
      },
      async getOnlineList(query) {
        const params = {
          room_id: this.roomId,
          limit: 200,
          pos: 0
        };
        if (query) {
          params.nickname = query;
        }
        const res = await this.lotteryServer.getOnlineUserList(params);
        if (res.code === 200) {
          this.onlineList = [];
          this.total = res.data.total;
          if (res.data.total) {
            let list = res.data.list.map(item => {
              return {
                key: item.account_id,
                join_id: item.join_id,
                room_id: item.room_id,
                subject: item.nickname,
                num: 0,
                label: item.nickname,
                type: 'user'
              };
            });
            this.onlineList.push(...list);
          }
        }
      },
      initChecked() {
        this.$refs.transfers && this.$refs.transfers.initChecked();
      }
      // async checkUserOnline() {
      //   const winners = this.winnerList.filter(e => e.type == 'user').map(e => e.key);
      //   const blacks = this.blackList.filter(e => e.type == 'user').map(e => e.key);
      //   let ids = [...winners, ...blacks].join(',');
      //   if (ids) {
      //     const params = {
      //       account_ids: ids,
      //       room_id: this.roomId
      //     };
      //     const res = await this.lotteryServer.checkUserOnline(params);
      //     if (res.code === 200) {
      //       const obj = res.data;
      //       for (let i in obj) {
      //         for (let j = 0; j < this.winnerList.length; j++) {
      //           if (this.winnerList[j].key == i) {
      //             this.$set(this.winnerList[j], 'online', obj[i]);
      //             break;
      //           }
      //         }
      //         for (let j = 0; j < this.blackList.length; j++) {
      //           if (this.blackList[j].key == i) {
      //             this.$set(this.blackList[j], 'online', obj[i]);
      //             break;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }
    },
    mounted() {
      const { watchInitData } = useRoomBaseServer().state;
      this.roomId = watchInitData?.interact?.room_id;
    }
  };
</script>
<style lang="less">
  .setting-audience-dialog {
    .audience-wrapper {
      width: 100%;
      &_list {
        // height: 360px;
        display: flex;
        justify-content: space-between;
        .list_left,
        .list_right {
          width: 260px;
        }
        .vh-checkbox-group {
          // display: flex;
          // flex-direction: column;
          padding-left: 12px;
          .vh-checkbox {
            height: 36px;
            line-height: 36px;
            display: block;
          }
          .vh-checkbox__label {
            color: #262626;
            font-weight: normal;
          }
          .vh-checkbox__input.is-checked + .vh-checkbox__label {
            color: #fb3a32;
          }
        }
        .audience_title {
          margin-top: 1px;
          height: 40px;
          background: #fafafa;
          line-height: 40px;
          padding-left: 12px;
          color: #262626;
          .vh-checkbox {
            padding-right: 2px;
          }
        }
        .list_left {
          border: 1px solid #d9d9d9;
          border-radius: 4px;
        }
        .list_right {
          &_wrap {
            height: 170px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            &:last-child {
              margin-top: 8px;
            }
          }
        }
        .list_center {
          display: flex;
          justify-content: space-around;
          flex-direction: column;
          &_wrap {
            text-align: center;
            span {
              display: inline-block;
              width: 32px;
              height: 32px;
              border: 1px solid #d9d9d9;
              border-radius: 4px;
              margin-top: 8px;
              cursor: pointer;
              i {
                line-height: 32px;
                font-size: 12px;
              }
            }
          }
        }
        .audience_list {
          height: calc(100% - 40px);
          overflow-y: auto;
        }
      }
      &_tip {
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
        margin-top: 8px;
      }
      &_btn {
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
</style>
